import { createSlice } from "@reduxjs/toolkit";
import { buscarConfiguracaoResultadoSorteio, buscarUltimaDataSorteioConfiguracao, listarConfiguracaoResultadoSorteio } from "../../../services/configuracaoResultadoSorteioService";
import { ConfiguracaoResultadoSorteioVMModel } from "../../../models/configuracaoResultadoSorteio/configuracaoResultadoSorteioVMModel";
import { ConfiguracaoResultadoSorteioModel } from "../../../models/configuracaoResultadoSorteio/configuracaoResultadoSorteioModel";
import { resetAll } from "../../actions/actions";

export interface ConfiguracaoResultadoSorteioState {
  //buscar configuracao resultado sorteio
  loading: boolean;
  list: ConfiguracaoResultadoSorteioVMModel[];
  entity: ConfiguracaoResultadoSorteioVMModel;
  //buscar historico configuracao resultado sorteio
  loadingHistorico: boolean;
  listHistorico: ConfiguracaoResultadoSorteioModel[];
  //internal
  page: string;
  editar: boolean;
}

const initialState: ConfiguracaoResultadoSorteioState = {
  //buscar configuracao resultado sorteio
  loading: false,
  list: [],
  entity: {} as ConfiguracaoResultadoSorteioVMModel,
  //buscar historico configuracao resultado sorteio
  loadingHistorico: false,
  listHistorico: [],
  //internal
  page: "geral",
  editar: false,
};

export const configuracaoResultadoSorteioSlice = createSlice({
  name: "configuracaoResultadoSorteio",
  initialState,
  reducers: {
    //buscar configuracao resultado sorteio
    setEntityConfiguracaoResultadoSorteio: (state, action) => {
      state.entity = action.payload;
    },
    //internal
    setPageConfiguracaoResultadoSorteio: (state, action) => {
      state.page = action.payload;
    },
    setEditarConfiguracaoResultadoSorteio: (state, action) => {
      state.editar = action.payload;
    },
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, () => initialState);

    //buscar configuracao resultado sorteio
    builder.addCase(buscarConfiguracaoResultadoSorteio.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarConfiguracaoResultadoSorteio.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarConfiguracaoResultadoSorteio.rejected, (state, action) => {
      state.loading = false;
    });

    //buscar ultima data sorteio configuracao
    builder.addCase(buscarUltimaDataSorteioConfiguracao.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarUltimaDataSorteioConfiguracao.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(buscarUltimaDataSorteioConfiguracao.rejected, (state, action) => {
      state.loading = false;
    });

    //buscar historico configuracao resultado sorteio
    builder.addCase(listarConfiguracaoResultadoSorteio.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(listarConfiguracaoResultadoSorteio.fulfilled, (state, action) => {
      state.listHistorico = action.payload;
      state.loading = false;
    });
    builder.addCase(listarConfiguracaoResultadoSorteio.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const {
  //buscar configuracao resultado sorteio
  setEntityConfiguracaoResultadoSorteio,
  //internal
  setPageConfiguracaoResultadoSorteio,
  setEditarConfiguracaoResultadoSorteio,
} = configuracaoResultadoSorteioSlice.actions;

export default configuracaoResultadoSorteioSlice.reducer;
